module.exports = __webpack_public_path__ + "static/media/aw-whistledog-2024-mb-en.41b1ce72.jpg";